var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 96 960 960",
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480 686q51.397 0 92.699-24Q614 638 639 598q-34-26-74.215-39t-85-13Q435 546 395 559t-74 39q25 40 66.301 64 41.302 24 92.699 24Zm.089-200Q509 486 529.5 465.411q20.5-20.588 20.5-49.5Q550 387 529.411 366.5q-20.588-20.5-49.5-20.5Q451 346 430.5 366.589q-20.5 20.588-20.5 49.5Q410 445 430.589 465.5q20.588 20.5 49.5 20.5ZM480 998Q311 854 227 730.985q-84-123.015-84-227.116 0-157.714 101.599-251.292Q346.198 159 479.908 159q133.711 0 235.401 93.577Q817 346.155 817 503.869q0 104.101-84 227.116Q649 854 480 998Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLocation);
export default __webpack_public_path__ + "static/media/user_location.554a58dfe67ab285e351839b43774d58.svg";
export { ForwardRef as ReactComponent };